/** Branch portal: card + sale price from transfer-in IMEI overrides */
export function getBranchProductDisplayPrices(product) {
  const rows = (product?.imeiTracking || []).filter(
    (r) =>
      String(r.status || 'available') === 'available' &&
      String(r.transferIn?.fromBranchId || '').trim()
  );
  const priced = rows.filter(
    (r) => Number(r.transferListPrice) > 0 || Number(r.transferOfferPrice) > 0
  );

  if (!priced.length) {
    const price = Number(product?.price) || 0;
    const offerRaw = Number(product?.offerPrice) || 0;
    const offer = offerRaw > 0 && offerRaw < price ? offerRaw : null;
    return { price, offer, salePrice: offer || price || 0 };
  }

  let list = 0;
  let offer = 0;
  if (priced.length === 1) {
    list = Number(priced[0].transferListPrice) || 0;
    offer = Number(priced[0].transferOfferPrice) || 0;
  } else {
    for (const r of priced) {
      const l = Number(r.transferListPrice) || 0;
      const o = Number(r.transferOfferPrice) || 0;
      const sell = o > 0 ? o : l;
      if (sell > 0 && (!offer || sell < offer)) offer = sell;
      if (l > list) list = l;
    }
    if (!list && offer > 0) list = offer;
  }

  const price = list > 0 ? list : offer;
  const cardOffer = offer > 0 && price > 0 && offer < price ? offer : null;
  return { price, offer: cardOffer, salePrice: cardOffer || price || 0 };
}

/** Local purchase / draft stock — sale price not set yet */
export function isProductPendingPricing(product) {
  if (product?.readyForSale === false) return true;
  if (product?.category === 'Old Mobile' && product?.imeiTracking?.length) {
    return product.imeiTracking.some(
      (r) => String(r.status || 'available') === 'available' && r.readyForSale === false
    );
  }
  return false;
}

/** Can this SKU be sold from branch New Sale? */
export function isProductSellable(product) {
  if (!product || (product.stock || 0) <= 0) return false;
  if (isProductPendingPricing(product)) return false;
  if (product.category === 'Old Mobile' && product.imeiTracking?.length) {
    const ready = product.imeiTracking.some(
      (r) => String(r.status || 'available') === 'available' && r.readyForSale !== false
    );
    if (!ready) return false;
  }
  const { salePrice } = getBranchProductDisplayPrices(product);
  return salePrice > 0;
}
